<template>
  <div class="alert-container">
    <b-alert
      v-for="(message, index) in messages"
      :key="index"
      show
      fade
      dismissible
      :variant="message.type"
    >
    <span v-html="message.text" @click="handleClick(message)"></span>
    </b-alert>
  </div>
</template>

<script>
import {
  sucessMessageListener,
  errorMessageListener,
  infoMessageListener,
  messageBus,
} from "./MessageBus";

export default {
  name: "MessageScreen",
  data() {
    return {
      messages: [],
      financial: {},
      baseTimeout: 3500,
    };
  },
  methods: {
    addErrorMessage(text, permanent) {
      this.messages.push({
        type: "danger",
        text,
      });
      if (!permanent) this.removeAlert(text);
    },
    addSuccessMessage(text, permanent) {
      this.messages.push({
        type: "success",
        text,
      });
      if (!permanent) this.removeAlert(text);
    },
    addInfoMessage(text, permanent, cb) {
      this.messages.push({
        type: "warning",
        text,
        cb
      });
      if (!permanent) this.removeAlert(text);
    },
    calculateTimeout(text) {
      const charCount = text.length;

      if (charCount <= 70) {
        return this.baseTimeout;
      }

      const additionalTimeout = Math.min((charCount - 70) * 50, 6500);
      return this.baseTimeout + additionalTimeout;
    },
    removeAlert(text) {
      const timeout = this.calculateTimeout(text);
      setTimeout(() => {
        this.messages.shift();
      }, timeout);
    },
    handleClick(message) {
      const clickedElement = event.target;
      if (clickedElement.id === 'reopen-folder' && message.cb) {
        message.cb();
        this.removeAlert(message);
      }
    },
  },
  mounted() {
    messageBus.$on(sucessMessageListener, (message, permanent) => {
      this.addSuccessMessage(message, permanent);
    });
    messageBus.$on(errorMessageListener, (message, permanent) => {
      this.addErrorMessage(message, permanent);
    });
    messageBus.$on(infoMessageListener, (message, permanent, cb) => {
      this.addInfoMessage(message, permanent, cb);
    });
  },
};
</script>

<style>
.alert-container {
  position: fixed;
  top: 5px;
  z-index: 10002;
  width: 30%;
  right: 15px;
}

@media (max-width: 1024px) {
  .alert-container {
    width: 60%;
  }
}

@media (max-width: 768px) {
  .alert-container {
    width: 90%;
    left: 5%;
    right: 5%;
  }
}
</style>
